module.exports = __webpack_public_path__ + "static/media/menu-settings-active.365187b5.svg";